import styled from "styled-components";

const TextRodeContainer = styled.div`
  ${({ theme }) => `padding: ${theme.sizes.sz8}`}
`;

export { TextRodeContainer };
